import { I } from '@angular/cdk/keycodes';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'motor-calculo-mensaje-bitacora',
  templateUrl: './mensaje-bitacora.component.html',
  styleUrls: ['./mensaje-bitacora.component.scss']
})
export class MensajeBitacoraComponent {
  @Input() nombreAgente = '';
  @Input() idAgente = '';
  @Input() fechaRegistro = '';  
  @Input() perfilAgente = '';  

}
